import styled from 'styled-components';

export const Indicator = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-left: -18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  color: #f78e1e;
  font-size: 18px;
  pointer-events: none;
`;
